export { default as CompaniesAdminDetails } from './CompaniesAdminDetails'


// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/components/index.ts